import React, { useState } from 'react';
import './App.css';

function FormPage() {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    hobbies: '',
    school: '',
    dailyRoutine: '',
    favoriteFood: '',
    favoriteMovie: '',
    interests: '',
    favoriteSubjects: '',
    futureAspiration: '',
    sports: '',
    freeTimeActivities: ''
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(`Form submitted: ${JSON.stringify(formData, null, 2)}`);
  };

  return (
    <div className="form-page">
      <h1>Tell us about Your Child</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">What is your child's name?</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="age">What is your child's age?</label>
          <input
            type="text"
            id="age"
            name="age"
            value={formData.age}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="hobbies">What is your child's hobbies? List them.</label>
          <input
            type="text"
            id="hobbies"
            name="hobbies"
            value={formData.hobbies}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="school">In which school your child studies in?</label>
          <input
            type="text"
            id="school"
            name="school"
            value={formData.school}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="dailyRoutine">Tell us in brief your child's daily schedule?</label>
          <input
            type="text"
            id="dailyRoutine"
            name="dailyRoutine"
            value={formData.dailyRoutine}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="favoriteFood">What is your child's favorite food?</label>
          <input
            type="text"
            id="favoriteFood"
            name="favoriteFood"
            value={formData.favoriteFood}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="favoriteMovie">Which movie does your child enjoys the most?</label>
          <input
            type="text"
            id="favoriteMovie"
            name="favoriteMovie"
            value={formData.favoriteMovie}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="interests">What are the interest of your child?</label>
          <input
            type="text"
            id="interests"
            name="interests"
            value={formData.interests}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="favoriteSubjects">What are your child's favourite subject in school?</label>
          <input
            type="text"
            id="favoriteSubjects"
            name="favoriteSubjects"
            value={formData.favoriteSubjects}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="futureAspiration">In future what does your child aspire to be?</label>
          <input
            type="text"
            id="futureAspiration"
            name="futureAspiration"
            value={formData.futureAspiration}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="sports">What sports does your child plays?</label>
          <input
            type="text"
            id="sports"
            name="sports"
            value={formData.sports}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="freeTimeActivities">What does your child do in his/her free time?</label>
          <input
            type="text"
            id="freeTimeActivities"
            name="freeTimeActivities"
            value={formData.freeTimeActivities}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
        <button type="submit" className="submit-button">Submit</button>
      </form>
    </div>
  );
}

export default FormPage;